var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowPagination = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none",
    viewBox: "0 0 13 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.4874 9.5062c-.1424 0-.269-.0475-.364-.1424-.2056-.1899-.2056-.522 0-.712l2.6737-2.6894-2.6736-2.6736c-.2057-.1899-.2057-.5221 0-.712.1898-.2056.522-.2056.712 0l3.0374 3.0375c.2057.19.2057.5221 0 .712L5.8354 9.3638a.49.49 0 0 1-.348.1424"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowPagination);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-pagination.a69ddb87d5f3293304669e7b5dda2ca2.svg";